import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl, Grid2 } from "@mui/material";
import './StateModal.scss'
import { useEffect, useRef } from "react";


const states = [
  { name: "Alabama", abbreviation: "AL" },
  { name: "Alaska", abbreviation: "AK" },
  { name: "Arizona", abbreviation: "AZ" },
  { name: "Arkansas", abbreviation: "AR" },
  { name: "California", abbreviation: "CA" },
  { name: "Colorado", abbreviation: "CO" },
  { name: "Connecticut", abbreviation: "CT" },
  { name: "Delaware", abbreviation: "DE" },
  { name: "Florida", abbreviation: "FL" },
  { name: "Georgia", abbreviation: "GA" },
  { name: "Hawaii", abbreviation: "HI" },
  { name: "Idaho", abbreviation: "ID" },
  { name: "Illinois", abbreviation: "IL" },
  { name: "Indiana", abbreviation: "IN" },
  { name: "Iowa", abbreviation: "IA" },
  { name: "Kansas", abbreviation: "KS" },
  { name: "Kentucky", abbreviation: "KY" },
  { name: "Louisiana", abbreviation: "LA" },
  { name: "Maine", abbreviation: "ME" },
  { name: "Maryland", abbreviation: "MD" },
  { name: "Massachusetts", abbreviation: "MA" },
  { name: "Michigan", abbreviation: "MI" },
  { name: "Minnesota", abbreviation: "MN" },
  { name: "Mississippi", abbreviation: "MS" },
  { name: "Missouri", abbreviation: "MO" },
  { name: "Montana", abbreviation: "MT" },
  { name: "Nebraska", abbreviation: "NE" },
  { name: "Nevada", abbreviation: "NV" },
  { name: "New Hampshire", abbreviation: "NH" },
  { name: "New Jersey", abbreviation: "NJ" },
  { name: "New Mexico", abbreviation: "NM" },
  { name: "New York", abbreviation: "NY" },
  { name: "North Carolina", abbreviation: "NC" },
  { name: "North Dakota", abbreviation: "ND" },
  { name: "Ohio", abbreviation: "OH" },
  { name: "Oklahoma", abbreviation: "OK" },
  { name: "Oregon", abbreviation: "OR" },
  { name: "Pennsylvania", abbreviation: "PA" },
  { name: "Rhode Island", abbreviation: "RI" },
  { name: "South Carolina", abbreviation: "SC" },
  { name: "South Dakota", abbreviation: "SD" },
  { name: "Tennessee", abbreviation: "TN" },
  { name: "Texas", abbreviation: "TX" },
  { name: "Utah", abbreviation: "UT" },
  { name: "Vermont", abbreviation: "VT" },
  { name: "Virginia", abbreviation: "VA" },
  { name: "Washington", abbreviation: "WA" },
  { name: "West Virginia", abbreviation: "WV" },
  { name: "Wisconsin", abbreviation: "WI" },
  { name: "Wyoming", abbreviation: "WY" },
];










export default function TenantModal({ open, onClose }) {
  const modalRef = useRef(null); // Create a reference for the modal content
  const [selectedState, setSelectedState] = React.useState("");


  const handleStateChange = (event) => {
    const selectedAbbreviation = event.target.value;
    const url = `https://www.hud.gov/sites/dfiles/PIH/documents/PHA_Contact_Report_${selectedAbbreviation}.pdf`;

    console.log(url); // Logs the generated URL

    // Open the URL in a new tab
    window.open(url, "_blank");
  };

  if (!open) return null; // Don't render the modal if not open

  if (!open) return null; // Render nothing if `open` is false


 




  return (
    <div className="modal-overlay">
      
      <div className="modal-content" style={{ maxWidth: '700px', overflow: 'auto' }}>
      <div style={{  marginRight: 0, display: 'flex' , justifyContent:'right', marginTop:'-13px' ,zIndex:1200}} >

<button onClick={onClose} >
X
</button>
</div>

      <div className="modal-header" style={{ textAlign: 'center' }}>
      <img
        src="https://cdn.prod.website-files.com/633c2bb2f45a991a63a2f570/6384f8ba891b89849a30a8c6_hero-owner-benefits.png" // Replace with your image URL
        alt="Welcome"
        style={{ width: '100%', height: 'auto', marginTop:"-10px",borderRadius: '8px' }}
      />
      <h3 style={{ marginTop: '-10px', fontSize: '30px', color: '#333' }}>
How do I Find Tenants?      </h3>
      <h3 style={{ marginTop: '10px', fontSize: '16px', color: '#333', padding: '0 10px', textAlign: 'center' }}>
      To find tenants for your Section 8 properties, start by listing your rental on platforms that <br/> connect property owners with individuals and families seeking affordable housing. <br/>These platforms often cater specifically to Section 8 voucher holders, giving you access <br/>to a large pool of potential tenants who are actively looking for subsidized housing. </h3> <br/>
      <h3 style={{  marginTop:'-15px',fontSize: '16px', color: '#333', padding: '0', textAlign: 'center' }}>
      When creating your property listing, be sure to highlight key details such as the rent price,<br/> number of bedrooms and bathrooms, and any additional amenities. It’s important to include <br/>information that makes your property attractive to potential tenants while ensuring <br/>compliance with Section 8 requirements. Many listing platforms also allow you to filter <br/>applicants based on certain criteria, helping you find tenants who meet the eligibility<br/> standards.           </h3>
       
    </div>

        {/* <form>
          <select id="state" name="state" defaultValue="" 
          style={{color:'black',
          textAlign:'center',
          textAlignLast:'center',
          padding:'8px',
          width:'100%'
          
          
          }} onChange={handleStateChange}>
            <option value="" disabled>
              -- Select a State --
            </option>
            {states.map((state) => (
              <option key={state.abbreviation} value={state.abbreviation}>
                {state.name}
              </option>
            ))}
          </select>
        </form> */}
<button
  style={{
    backgroundColor: '#007BFF', // Clean blue color
    color: 'white', // White text
    border: 'none', // No border
    padding: '10px 20px', // Padding for better spacing
    fontSize: '16px', // Text size
    borderRadius: '5px', // Rounded corners
    cursor: 'pointer', // Pointer cursor on hover
    transition: 'background-color 0.3s, transform 0.2s', // Smooth transition for hover effects
    marginTop: '10px', // Keep margin from top
    width: '30%', // Make it full width (optional)
  }}
  onClick ={()=> window.open('https://www.affordablehousing.com/list-your-property/', "_blank")}  onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'} // Darker blue on hover
  onMouseLeave={(e) => e.target.style.backgroundColor = '#007BFF'} // Revert back on hover out
>
  Find my Tenants
</button>      </div>
    </div>
  );
};